import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getErrorMessageFromAPI } from '@/utilz';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import {
  type ApplyOCClaimRecoveryPercentParams,
  applyOCClaimRecoveryPercent,
} from '@/views/screens/Claims/OverCharge/data-provider/apply-claim-recovery';

export type { ApplyOCClaimRecoveryPercentParams };

export const useApplyOCClaimRecoveryPercent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: applyOCClaimRecoveryPercent,
    onError: (error: { response: unknown }) => {
      showNotification({
        message: getErrorMessageFromAPI(error),
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['claims-over-charge-items', variables.fbOcKey] });
      showNotification({
        message: 'Claim Recovery Applied Successfully',
        type: NOTIFICATION_TYPES.SUCCESS,
      });
    },
  });
};
